// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export interface Version {
    version: string;
    branch: string;
    hash: string;
    buildAt: string;
    [K:string]: string|boolean|null;
}
export const VERSION = {
    "dirty": true,
    "raw": "8cff0ba-dirty",
    "hash": "8cff0ba",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8cff0ba-dirty",
    "semverString": null,
    "version": "1.18.2",
    "buildAt": "2025-06-18T15:47:24.828Z",
    "branch": "HEAD"
};
/* tslint:enable */
